"use strict";
import axios, { CancelTokenSource } from "axios";
import store from "@/store/index";
import { refreshToken } from './loginUtils';


export interface PostData {
  token: string;
  body: any; // eslint-disable-line
}

export type errorFuncStruct = (code?: number) => void;

// eslint-disable-next-line
export function checkErrorCode(error: null | any): number{
  if(error && error.response && error.response.status == 401){
    return 401;
  }
  else{
    return 0;
  }
}

export function checkResponseData(
  response: undefined | null | any, // eslint-disable-line
  fields: Array<string>
): boolean{
  if(response && response.data){
    let flagExist = true;
    fields.forEach(field => {
      if(!response.data[field]){
        flagExist = false;
      }
    });
    if(flagExist) return true;
    else return false;
  } else {
    return false;
  }
}

function error401Handling(
  file: string,
  objectPost: any, // eslint-disable-line
  cbOk: (responseBody: any) => void,// eslint-disable-line
  cbError: errorFuncStruct,
  attempts: number,
  error: number
){
  if(error == 401 && attempts == 0){
    refreshToken(() => {
      conection( // eslint-disable-line
        file,
        objectPost,
        cbOk,
        cbError,
        attempts+1
      );
    });
  } else {
    cbError(error);
  }
}

export function conection(
  file: string,
  objectPost: any,// eslint-disable-line
  cbOk: (responseBody: any) => void,// eslint-disable-line
  cbError: errorFuncStruct,
  attempts = 0
) {
  const server = store.getters.configs.server;
  const token = store.getters.token;
  const postBody: PostData = {
    token: token,
    body: objectPost
  }
  axios.post(server + file, postBody)
    .then(response => {
      if(response.data.status === true){
        cbOk(response.data.body);
      }
      else{
        error401Handling(file, objectPost,cbOk, cbError, attempts, response.data);
      }
    })
    .catch(error => {
      error401Handling(file, objectPost,cbOk, cbError, attempts, checkErrorCode(error));
    });
}

export class LongPoll{
  readonly timeoutFlag = "ECONNABORTED";
  private fails = 0;
  private timeout: ReturnType<typeof setTimeout> | null = null;
  private file = "";
  private cancel_token: CancelTokenSource | null = null;

  private server = store.getters.configs.server;
  private token = store.getters.token;
  private postBody: PostData = {
    token: this.token,
    body: null
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private cbOk: ((responseBody: any) => void) | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private cbError: ((err: any) => void) | null;


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(file: string, object: any, cbOk: ((responseBody: any) => void) | null, cbError: ((err: any) => void) | null) {
    if(!file){
      throw new Error("No file url");
    }
    this.file = file;
    this.postBody.body = object;
    this.cbOk = cbOk;
    this.cbError = cbError;
  }

  poll(): void {
    if(this.timeout){
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    this.cancel_token = axios.CancelToken.source();
    axios.post(this.server + this.file, this.postBody, {
      cancelToken: this.cancel_token.token,
      timeout: 30000
    })
    .then(response => {
      if(response.data.status === true){
        if(this.cbOk != null){
          this.cbOk(response.data.body);
        }
      }
      else{
        this.fails++;
        if(this.cbError != null){
          this.cbError(response.data.body);
        }
      }
    })
    .catch(error => {
      if (!axios.isCancel(error)){
        if(error.code != this.timeoutFlag)
          this.fails++;
        if(this.cbError != null){
          this.cbError(error.code ? error.code : error);
        }
      }
    });

  }

  get fail_counter(): number {
    return this.fails;
  }
  
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set body(body: any) {
    this.postBody.body = body;
  }
  

  cancel(): void {
    if(this.cancel_token){
      this.cancel_token.cancel();
      this.cancel_token = null;
    }
    if(this.timeout){
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  setCounter(time: number): void {
    if(this.timeout){
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.timeout = setTimeout(() => {
      this.poll();
    }, time);
  }


}

export class LongPollLog extends LongPoll{
  last_log_id: number;
  getData: ( () => void ) | null;
  constructor(last_log_id: number, getData: ( () => void ) | null){
    super(
      "long_poll.php",
      {lastid: last_log_id},
      (resp) => {
        // console.log("resp: ",resp);
        if(resp.total > 0 && resp.last_id){
          this.last_log_id = resp.last_id;
          
          this.body = {lastid: this.last_log_id};
          this.cancel();
          
          if(this.getData)
            this.getData();
        }
        else {
          this.setCounter(2000);
        }
      },
      (err) => {
        // console.log("err: ",err);
        if(err == this.timeoutFlag){
          this.setCounter(2000);
        }
        else if(err && err.error && err.error == "nolastid"){
          if(this.fail_counter <= 3 ){
            if(this.getData)
              this.getData();
          }
        }
        else{
          if(this.fail_counter <= 3 ){
            this.setCounter(30000);
          }
        }
      
      }
    );
    this.last_log_id = last_log_id;
    this.getData = getData;
  }
}
